// extracted by mini-css-extract-plugin
export default {"privacy-policy":"privacy-policy_privacy-policy__qHRGU","heading":"privacy-policy_heading__F+zHn"};